import { SelectOption } from '@touche-lts/panel-ui/dist'
import { TriggerSearchFunc, OrdersTableBase } from 'mobx-stores/utils'
import { OrdersTableStatus } from 'mobx-stores/utils/orders-table-base/orders-table-base.types'
import { OrdersPeriodFilter } from 'models'
import { getSelectOptions } from 'utilities'

export class OrdersTableStore extends OrdersTableBase {
  private rootStore:any

  constructor (rootStore:any) {
    super()
    this.rootStore = rootStore
  }

  // ACTIONS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {

    let assignedId = null;
    let searchData = null;

    if(window.location.href.indexOf('/account/orders') > -1) {
      assignedId = JSON.parse(localStorage.getItem('userDetails'))?.id;
      searchData = await this.rootStore.generalStore.api.storeApi.customerOrders(
        assignedId,
        this.ordersFilter,
        { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
      )
    } else {
      assignedId = JSON.parse(localStorage.getItem('UserStore'))?.assignedStore?.id;
      if (!assignedId) return
      searchData = await this.rootStore.generalStore.api.storeApi.storeOrdersFiltered(
        assignedId,
        this.ordersFilter,
        { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
      )
    }

    this.handleSearchResult(searchData)
  }

  // COMPUTED
  public get ordersPeriodFilterOptions (): SelectOption<OrdersPeriodFilter>[] {
    return getSelectOptions(OrdersPeriodFilter)
  }

  public get statusTableHeader(): SelectOption<OrdersTableStatus>[] {
    return Object.values(OrdersTableStatus).map(type => ({
      label: this.statusShown(type),
      value: type
    })) 
  }

  // METHODS
  public statusShown(status: string): string {
    return (status.charAt(0).toUpperCase() + status.slice(1)).replaceAll('_', ' ');
  }

  // METHODS
  public handleSendOrderToShopify = async(payload: {store_id : number,number:number}): Promise<void> => {
    try {
      await this.rootStore.generalStore.api.storeApi.sendOrderToShopify(payload)
      await this.triggerSearch()
    } catch (error) {
      error = JSON.parse(error?.message)
      this.rootStore.generalStore.showError(error.errors)
    }
  }
}
